import { gql } from "@apollo/client"

export const EMPLOYEE_ACCESS = gql`
  query EmployeeAccess {
    canViewEmployees
    canManageEmployees
  }
`
const fields = gql`
  fragment EmployeeFields on User {
    id
    name
    fullName
    username
    email
    personalEmail
    phoneNumber
    employeeCode
    department
    gender
    position
    dob
    joinedCompanyAt
    attendee {
      name
      id
      discordId
      discordName
      discordAvatarUrl
      keycloakUsername
      telegramUsername
      isPartTime
      isResigned
    }
  }
`
export const EMPLOYEES = gql`
  query Employees(
    $offset: Int!
    $limit: Int!
    $search: String
    $department: String
    $position: UserPosition
    $isPartTime: Boolean
    $isResigned: Boolean
    $incomplete: Boolean
    $sortBy: String!
    $descending: Boolean!
  ) {
    employeesPage(
      offset: $offset
      limit: $limit
      search: $search
      department: $department
      position: $position
      isPartTime: $isPartTime
      isResigned: $isResigned
      incomplete: $incomplete
      sortBy: $sortBy
      descending: $descending
    ) {
      total
      items {
        ...EmployeeFields
      }
    }
  }
  ${fields}
`
export const UPDATE_EMPLOYEE = gql`
  mutation UpdateEmployee($id: Int!, $input: UpdateEmployeeInput!) {
    updateEmployee(id: $id, input: $input) {
      ...EmployeeFields
    }
  }
  ${fields}
`

export const EMPLOYEE_DEPARTMENTS = gql`
  query EmployeeDepartments {
    employeeDepartments
  }
`
